// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__1EDsc","container":"styles_container__mltS2","title":"styles_title__3R7y-","wrapper":"styles_wrapper__3bch_","answer":"styles_answer__2DeGU"};